import { render, staticRenderFns } from "./ListDisposicionCards.vue?vue&type=template&id=60ac8763&"
import script from "./ListDisposicionCards.vue?vue&type=script&lang=js&"
export * from "./ListDisposicionCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports